<template>
  <div>
    <wc-page-title v-if='expense' title='Expense Detail'>
      <template v-slot:rightSide>
        <posted-chip :posted='expense.is_posted'></posted-chip>
        <wc-burger-menu>
          <v-list-item @click='showConfirmUnpost = true' :disabled='!expense.is_posted'>
            <v-list-item-icon>
              <v-icon color='warning'>mdi-stamper</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>UN-Post Expense</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click='showConfirmDelete = true' :disabled='expense.reconciliation !== null || expense.is_posted == true'>
            <v-list-item-icon>
              <v-icon color='error'>mdi-close</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Delete Expense</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </wc-burger-menu>
      </template>
    </wc-page-title>
    <router-view
      v-if='expense'
      :expense='expense'
      :staff='staff'
      :payment_accounts='payment_accounts'
      ref='router'
      @update='update'
      @newAction='newAction'
    ></router-view>

    <expense-tracker ref='actionTracker' v-if='expense' :expense='expense'></expense-tracker>

    <!-- Confirm Delete --> 
    <wc-confirm
      :showDialog='showConfirmDelete'
      @cancel='showConfirmDelete = false'
      @confirm='deleteExpense'
    >
      Are you sure you want to <strong><u>fully delete</u></strong> this expense?<br>
      <br>
      This cannot be undone and is <strong><u>not the same as archiving!</u></strong>
    </wc-confirm>

    <!-- Confirm Un-Post -->
    <wc-confirm
      :showDialog='showConfirmUnpost'
      @cancel='showConfirmUnpost = false'
      @confirm='unpost'
    >
      Are you sure you want to <strong><u>UN-Post</u></strong> this expense and remove it from the accounting records?<br>
      <br>
      This does not delete or archive the expense, but it will have larger consequences.<br>
      <br>
      Please ensure you know what you are doing,
      or have been authorized to un-post this expense!
    </wc-confirm>


    <v-dialog
      hide-overlay
      persistent
      v-model='showDeleteDialog'
      width='300'
    >
      <v-card dark color='primary'>
        <v-card-text class='py-2 px-3'>
          Processing...
          <wc-loading line></wc-loading>
        </v-card-text>
      </v-card>
    </v-dialog>

   </div>
</template>

<script>
import staffingAPI from '@/modules/staffing/api/staffing';
import WCPosted from '@/components/chips/WCPosted';
import accountingAPI from '@/api/accounting';
import ExpenseTracker from '@/components/trackers/ExpenseTracker';
import trackerAPI from '@/api/tracker';
import _ from 'lodash';
import moment from 'moment';

export default {
  name: 'expense-base',
  data: () => ({
    isLoading: true,
    expense: null,
    showConfirmDelete: false,
    showConfirmUnpost: false,
    showDeleteDialog: false,
    staff: [],
    payment_accounts: [],
    expenseCopy: {
      expense_date: null
    }
  }),
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.expense = await accountingAPI.getExpense(this.$route.params.id)
      this.payment_accounts = await accountingAPI.getPaymentAccounts()
      this.staff = await staffingAPI.getProfiles()
      this.isLoading = false
    },
    async update (exp) {
      this.isLoading = true
      this.expense = await accountingAPI.updateExpense(exp.id, exp)
      this.isLoading = false
    },
    async unpost () {
      this.showDeleteDialog = true
      this.showConfirmUnpost = false
      this.expenseCopy = _.cloneDeep(this.expense)
      this.expenseCopy.is_posted = false
      this.expense = await accountingAPI.updateExpense(this.expenseCopy.id, this.expenseCopy)

      // Action tracker
      const tracker = {
        tracker_data: {
          action_date: moment().format('YYYY-MM-DD').toString(),
          taken_by: this.$store.state.auth.profile.id,
          description: "UN-Posted expense, removed from accounting records"
        },
        expense: this.expense.id
      }
      const res = await trackerAPI.createExpenseTracker(tracker);
      this.$refs.actionTracker.pushItem(res);
      this.showDeleteDialog = false;
    },
    async deleteExpense () {
      this.showDeleteDialog = true
      this.showConfirmDelete = false
      await accountingAPI.deleteExpense(this.expense.id);
      this.$router.push({ name: 'PostExpenses' })
      this.showDeleteDialog = false
    },
    newAction (res) {
      this.$refs.actionTracker.pushItem(res)
    }
  },
  components: {
    'posted-chip': WCPosted,
    'expense-tracker': ExpenseTracker
  }
}

</script>
